export const MOOD_SURVEY_SUBTITLE =
  "We'll share this with your provider so you can process whatever you may be feeling together.";
export const MOOD_SURVEY_CUSTOM_RESPONSE_PLACEHOLDER =
  "Share any other emotion you might be feeling";

export const MOOD_SURVEY_CUSTOM_RESPONSE_TITLE = "Something else";

export const MOOD_SURVEY_SAVE_AND_CLOSE_BUTTON_TEXT = "Save & close";
export const MOOD_SURVEY_PREVIOUS_BUTTON_TEXT = "Previous";

export const MOOD_SURVEY_HEADER_TEXT = "How are you feeling today?";
